export default __webpack_public_path__ + "static/media/todo.f133e287.png";